module.exports = __webpack_public_path__ + "img/Leon.a7696097.png";